// import React from 'react'

// const SaveIcon = () => {
//   return (
//     <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="36" height="32" rx="4" fill="#52CBC4" /> <path d="M12.1667 23.5H23.8333C24.7538 23.5 25.5 22.7538 25.5 21.8333V13.357C25.5 12.915 25.3244 12.4911 25.0118 12.1785L21.8215 8.98816C21.5089 8.67559 21.085 8.5 20.643 8.5H12.1667C11.2462 8.5 10.5 9.24619 10.5 10.1667V21.8333C10.5 22.7538 11.2462 23.5 12.1667 23.5Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" /> <path d="M13.833 8.5V12.6667H20.4997V8.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" /> <path d="M13.833 23.5V18.5H22.1663V23.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" /> </svg>
    
//   )
// }

// export default SaveIcon


import React from 'react'

const SaveIcon = ({disabled=false}) => {
  return disabled ? (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<rect x="2" y="1" width="40" height="40" rx="16" fill="#EBEBED"/>
<path d="M15 30H29C30.1046 30 31 29.1046 31 28V17.8284C31 17.298 30.7893 16.7893 30.4142 16.4142L26.5858 12.5858C26.2107 12.2107 25.702 12 25.1716 12H15C13.8954 12 13 12.8954 13 14V28C13 29.1046 13.8954 30 15 30Z" stroke="#F6F6F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17 12V17H25V12" stroke="#F6F6F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17 30V24H27V30" stroke="#F6F6F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_dd_411_32912" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_32912"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_411_32912" result="effect2_dropShadow_411_32912"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_32912" result="shape"/>
</filter>
</defs>
</svg>

  ): (
<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<rect x="2" y="1" width="40" height="40" rx="16" fill="#52CBC4"/>
<path d="M15 30H29C30.1046 30 31 29.1046 31 28V17.8284C31 17.298 30.7893 16.7893 30.4142 16.4142L26.5858 12.5858C26.2107 12.2107 25.702 12 25.1716 12H15C13.8954 12 13 12.8954 13 14V28C13 29.1046 13.8954 30 15 30Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17 12V17H25V12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17 30V24H27V30" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_dd_411_28995" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_28995"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_411_28995" result="effect2_dropShadow_411_28995"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_28995" result="shape"/>
</filter>
</defs>
</svg>

  )
}

export default SaveIcon
